<template lang="pug">
<div>
  nuxt(keep-alive style='min-height:calc(100vh - 78px - 150px)' :key="$route.fullPath")
</div>
</template>

<script>
export default {
  name: 'tv-vip',
  data() {
    return {
      disabled: true,
      noShow: ['screen'],
      include: { include: ['home', 'screen'] }
    }
  },

  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.$Lazyload.$on('error', (target) => {
      target.el.src = 'https://static.loklok.video/img/default-sq.png'
    })
    console.log('$i18n.localeProperties', this.$i18n.localeProperties)
    if (this.$i18n.localeProperties.code == 'ar') {
      document.documentElement.setAttribute('dir', 'rtl')
    } else {
      document.documentElement.setAttribute('dir', 'ltr')
    }
  }
}
</script>

<style lang="sass">
// @import '~/styles/index.sass'
</style>
